/** Decode the donor's text encoding only. Never strip team qualifiers,
 * transliterate names, interpret HTML, or guess aliases for execution. */
const named:Record<string,string>={amp:'&',quot:'"',apos:"'",lt:'<',gt:'>',nbsp:' '};
function decodePass(raw:string):string {
  return raw.replace(/&(#x[0-9a-f]+|#\d+|amp|quot|apos|lt|gt|nbsp);/gi,(all:string,code:string)=>{
    if(!code.startsWith('#'))return named[code.toLowerCase()]??all;
    const hex=code[1]?.toLowerCase()==='x';
    const point=Number.parseInt(code.slice(hex?2:1),hex?16:10);
    if(!Number.isSafeInteger(point)||point<32||point>0x10ffff
      ||point>=0x7f&&point<=0x9f||point>=0xd800&&point<=0xdfff)return all;
    return String.fromCodePoint(point);
  });
}
export function participantText(raw:string):string {
  if(!raw.includes('&'))return raw;
  const once=decodePass(raw),twice=decodePass(once);
  // Both the row and older extension envelopes can pass this boundary. Deep
  // or malformed escaping stays literal instead of changing on each replay.
  return decodePass(twice)===twice?twice:raw;
}
